import React from 'react'
import { displayDollar } from '../../lib/utils/helpers'
import { InvestmentFee } from '../../services/types'

const FEE_LABELS: Record<string, string> = { salesFee: 'Upfront Fees' }

/** showCents keeps cents visible (share-priced orders, where fees are not whole dollars). */
export const renderFeeRow = (fee: InvestmentFee, currencyCode: string, showCents = false) => {
  const value = fee.appliedAmount ? Math.round(fee.appliedAmount * 100) : 0
  const name =
    FEE_LABELS[fee.name] ??
    fee.name.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())
  return (
    <div className='property-row' key={fee.name}>
      <span className='property-column-left' data-testid={`${fee.name}-text`}>
        {name} ({fee.value}%):
      </span>
      <span className='property-column-right' data-testid={`${fee.name}-value`}>
        {displayDollar(value.toString(), currencyCode, 2, true, showCents)}
      </span>
    </div>
  )
}
